/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Confirm_CtaInputs */

const cs_ebr_confirm_cta = /** @type {(inputs: Ebr_Confirm_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spustit import`)
};

const en_ebr_confirm_cta = /** @type {(inputs: Ebr_Confirm_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run import`)
};

/**
* | output |
* | --- |
* | "Run import" |
*
* @param {Ebr_Confirm_CtaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_confirm_cta = /** @type {((inputs?: Ebr_Confirm_CtaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Confirm_CtaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_confirm_cta(inputs)
	return cs_ebr_confirm_cta(inputs)
});